let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dnyoG")).then(() => parcelRequire('lOgAb'));